import paredAnalytics from 'pared/analytics/utils/ParedAnalytics'

export const track = {
  async storeChanged(newStoreId: string) {
    await paredAnalytics.track('StoreSelector - Store Changed', { newStoreId })
  },
}
